import { axios } from "../lib/axios";

export const signup = async function (model) {
  try {
    const response = await axios.post("auth/signup", model, {
      headers: { "Content-type": "application/json" },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const login = function (model) {
  return axios.post("auth/login", model, {
    headers: { "Content-type": "application/json" },
  });
};

export const logout = async function () {
  try {
    const response = await axios.post("auth/logout", {
      headers: { "Content-type": "application/json" },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const forgotPassword = (email) =>
  axios.post("auth/password/forgot", { email });

export const resetPassword = (values) => axios.post("auth/password/reset", values);